<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group
                label="Nome"
                label-for="v-nome"
              >
                <b-form-input
                  id="v-nome"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  data-cy="nome-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-nome-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Procedimento"
              rules="required"
            >
              <b-form-group
                label="Procedimento"
                label-for="v-procedimento"
              >
                <v-select
                  v-model="form.procedimento.id"
                  :reduce="(comboProcedimentos) => comboProcedimentos.id"
                  label="nome"
                  :options="comboProcedimentos"
                  :state="errors.length > 0 ? false : null"
                  data-cy="procedimento-select"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-procedimento-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Tipo Campo"
              rules="required"
            >
              <b-form-group
                label="Tipo Campo"
                label-for="v-tipo"
              >
                <v-select
                  v-model="form.tipo"
                  :options="comboTipoCampo"
                  :reduce="(comboProcedimentos) => comboProcedimentos.value"
                  :state="errors.length > 0 ? false : null"
                  data-cy="tipo-select"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-tipo-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('combosModule', {
      comboProcedimentos: state => state.comboProcedimentos,
    }),
    ...mapState('camposAdicionaisSettingsModule', {
      campoAdicional: state => state.campoAdicional,
    }),
    canInsert() {
      return this.verificarPermissao('ROLE_CAMPO_ADICIONAL_INSERIR')
    },
    canEdit() {
      return this.verificarPermissao('ROLE_CAMPO_ADICIONAL_ATUALIZAR')
    },
    canEditOrInsert() {
      if (this.form.id) {
        return this.canEdit
      }
      return this.canInsert
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Campo Adicional',
      required,
      form: {
        id: null,
        nome: '',
        descricao: '',
        procedimento: {
          id: null,
        },
        ativo: true,
      },
      comboTipoCampo: [
        {
          value: 'STRING',
          label: 'Texto',
        },
        {
          value: 'TEXTO',
          label: 'Area para Texto',
        },
        {
          value: 'NUMBER',
          label: 'Número',
        },
        {
          value: 'DECIMAL',
          label: 'Decimal, Ex: 10.50',
        },
        {
          value: 'DATA',
          label: 'Data',
        },
        {
          value: 'BOOLEAN',
          label: 'Verdadeiro ou Falso',
        },
      ],
    }
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.campoAdicional))
    await this.$store.dispatch('combosModule/loadComboProcedimentos')
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('camposAdicionaisSettingsModule/reset')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('camposAdicionaisSettingsModule/edit', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }

                if (response.error) {
                  this.MensagemError('Falha ao Editar', response.message)
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('camposAdicionaisSettingsModule/insertNew', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        id: null,
        nome: '',
        descricao: '',
        procedimento: {
          id: null,
        },
        ativo: true,
      }
    },
  },
}
</script>
